import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stack,
    CircularProgress
} from '@mui/material';

import {
    createPrintingProcess
} from '../../services/PrintingProcessService';

const PrintingProcessCreate = ({
    open,
    onClose,
    onSuccess
}) => {

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        printed_quantity: '',
        rejected_quantity: '',
    });

    const [errors, setErrors] = useState({});

    /**
     * Handle input change
     */
    const handleChange = (event) => {

        const {
            name,
            value
        } = event.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    /**
     * Reset form
     */
    const resetForm = () => {

        setFormData({
            printed_quantity: '',
            rejected_quantity: '',
        });

        setErrors({});
    };

    /**
     * Close dialog
     */
    const handleClose = () => {

        if (loading) {
            return;
        }

        resetForm();
        onClose();
    };

    /**
     * Validate form
     */
    const validate = () => {

        const newErrors = {};

        if (
            formData.printed_quantity === '' ||
            Number(formData.printed_quantity) < 0
        ) {
            newErrors.printed_quantity =
                'Printed quantity is required.';
        }

        if (
            formData.rejected_quantity !== '' &&
            Number(formData.rejected_quantity) < 0
        ) {
            newErrors.rejected_quantity =
                'Rejected quantity cannot be negative.';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    /**
     * Submit
     */
    const handleSubmit = async () => {

        if (!validate()) {
            return;
        }

        try {

            setLoading(true);

            const payload = {
                printed_quantity:
                    Number(formData.printed_quantity),

                rejected_quantity:
                    formData.rejected_quantity === ''
                        ? 0
                        : Number(formData.rejected_quantity),
            };

            await createPrintingProcess(payload);

            resetForm();

            onSuccess();

        } catch (error) {

            console.error(
                'Create Printing Process Error:',
                error
            );

            if (error.response?.status === 422) {

                setErrors(
                    error.response.data.errors || {}
                );

            } else {

                console.error(
                    error.response?.data?.message ||
                    'Failed to create Printing Process.'
                );
            }

        } finally {

            setLoading(false);
        }
    };

    return (

        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >

            <DialogTitle>
                Add Painting Process
            </DialogTitle>

            <DialogContent>

                <Stack
                    spacing={1}
                    sx={{ mt: 1 }}
                >

                    {/* Paint Quantity */}
                    <TextField
                        label="Paint Quantity"
                        name="printed_quantity"
                        type="number"
                        fullWidth
                        required
                        value={formData.printed_quantity}
                        onChange={handleChange}
                        error={
                            Boolean(
                                errors.printed_quantity
                            )
                        }
                        helperText={
                            errors.printed_quantity
                        }
                        inputProps={{
                            min: 0
                        }}
                    />

                    {/* Rejected Quantity */}
                    <TextField
                        label="Rejected Quantity"
                        name="rejected_quantity"
                        type="number"
                        fullWidth
                        value={formData.rejected_quantity}
                        onChange={handleChange}
                        error={
                            Boolean(
                                errors.rejected_quantity
                            )
                        }
                        helperText={
                            errors.rejected_quantity
                        }
                        inputProps={{
                            min: 0
                        }}
                    />

                </Stack>

            </DialogContent>

            <DialogActions>

                <Button
                    onClick={handleClose}
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                >

                    {loading ? (
                        <CircularProgress size={22} />
                    ) : (
                        'Save'
                    )}

                </Button>

            </DialogActions>

        </Dialog>
    );
};

export default PrintingProcessCreate;